<template>
    <div v-bind:class="['notification', { 'top': isOverflown}]"
         :name="name"
         v-click-outside="onClickOutside">
        <div class="flex">
            <div style="width:100%"></div>
            <a class="flex" href="javascript:;" @click="menuClick">
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="styleBell">
                    <use :xlink:href="'/Content/dist/image_svg.svg?v1#Bell'"></use>
                </svg>
                <span class="menu-item-info count-info">{{ totalCount }}</span>
            </a>
        </div>
        <div :class="['notification-block', {'notification-open': notificationOpen}]">
            <div class="notification-list">
                <div :class="['notification-item', {'no-viwed':!item.Viewed}]" v-for="item of notificationItems" v-bind:style="[item.Viewed ? {'border-color': 'none'} : {'border-color': menuColor}] ">
                    <div class="flex" @click="gotoPage(item)">
                        <div>
                            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor }">
                                <use :xlink:href="item.img"></use>
                            </svg>
                            <div v-if="!item.Viewed" class="notification-circle margin-top-10 margin-left-5" v-bind:style="{background: menuColor }"></div>
                        </div>
                        <div class="form-field">
                            <span>{{item.PageText}}</span>
                            <p v-if="item.isSystem" class="panel-body-desc">{{item.Body}}</p>
                            <p v-else class="panel-body-desc" v-html="item.Body"></p>
                            <p class="input-text-lbl">{{item.CreateDateFormatted}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex margin-top-20 margin-right-10">
                <div v-if="canBeLoaded" class="flex margin-top-3" @click="loadNext()" style="width:120px">
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor }">
                        <use :xlink:href="'/Content/dist/image_svg.svg?v1#ArrowDownCircle'"></use>
                    </svg>
                    <span>Показать ещё</span>
                </div>
                <div style="width:100%"></div>
                <div class="margin-top-3">
                    <span @click="close()">Отмена</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import BackendApi from '../backendApi'
    import moment from 'moment'

    let backendApi = new BackendApi();

    function isOverflown(element) {
        if(!element){
            return false;
        }
        /*console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
            [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);*/
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }

        export default {
        name: "notification",

        props: ['name', 'value', 'menuColor', 'info'],

         data(){
            return{
                notificationOpen: false,
                notificationItems: [],
                isOverflown: false,
                page: 0,
                canBeLoaded: true,
                loading: false,
                scrollTop: null,
                rowsPerPage: 5,
                firstLoad: true,
                totalCount: 0
            }
        },

        watch:{
            notificationOpen(){
                let vm = this;
                if (vm.notificationOpen){
                    vm.$nextTick(() => {
                        vm.isOverflown = isOverflown($(vm.$el).parents('.block-in-page-detail:first').get(0));
                    });
                }else{
                    vm.isOverflown = false;
                }
            },
            value(newVal, oldVal) {
                this.totalCount = newVal;
            }
        },

        computed: {
            styleBell: function () {
                return {
                    fill: this.notificationOpen ? this.menuColor : null
                }
            }
        },

        methods: {
            menuClick() {
                this.notificationOpen = !this.notificationOpen;
                //console.info('menuClick notificationOpen=', this.notificationOpen);
                if (this.notificationOpen) {
                    this.reload();
                }
            },

            reload() {
                this.page = 0;
                this.notificationItems = [];
                this.loading = false;
                this.canBeLoaded = true;

                this.loadNext();
            },

            gotoPage(item) {
                if(item.PathToOpen) {
                    this.close();
                    this.$router.push(item.PathToOpen);
                }
            },

            loadNext() {
                let vm = this;
                if (!vm.canBeLoaded || vm.loading) {
                    return;
                }
                this.loading = true;
                let skip = vm.page * vm.rowsPerPage;
                let take = vm.rowsPerPage;

                return backendApi.commonNotificationList(skip, take).then(function (response) {
                    console.info('commonNotificationList -> load, response:', response, vm.info);
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке уведомлений');
                    }
                    else {
                        if (response.data.NotificationsList && response.data.NotificationsList.length) {
                            vm.totalCount = response.data.NotificationsLength;
                            //vm.notificationItems = Object.assign(response.data.NotificationsList, {});

                            let oldLength = vm.notificationItems.length;

                            vm.notificationItems.push(...response.data.NotificationsList);

                            let urlImg = '/Content/dist/images.svg?v3#Menu';
                            for (let r = oldLength; r < vm.notificationItems.length; r++) {
                                vm.notificationItems[r].CreateDateFormatted = moment(vm.notificationItems[r].CreateDate).format('DD.MM.YYYY');
                                let path = '/' + vm.notificationItems[r].Page;
                                let projectPage = vm.info.Pages.find(x => x.Path === path);
                                switch (vm.notificationItems[r].Page) {
                                    case 'news':
                                        vm.notificationItems[r].img = urlImg + 'News';
                                        projectPage = vm.info.Pages.find(x => x.Path === '/');
                                        break;
                                    case 'materials':
                                        vm.notificationItems[r].img = urlImg + 'Material';
                                        break;
                                    case 'profile':
                                        vm.notificationItems[r].img = urlImg + 'Profile';
                                        break;
                                    case 'reports':
                                        vm.notificationItems[r].img = urlImg + 'Doc';
                                        break;
                                    case 'tasks':
                                        vm.notificationItems[r].img = urlImg + 'Tasks';
                                        break;
                                    case 'cart':
                                        vm.notificationItems[r].img = urlImg + 'Cabinet';
                                        break;
                                }
                                if(projectPage && projectPage.Name && vm.notificationItems[r].isSystem) {
                                    vm.notificationItems[r].PageText = projectPage.Name;
                                }
                            }

                        } else {
                            vm.canBeLoaded = false;
                        }
                    }
                    vm.loading = false;
                    vm.page++;
                });
            },

            close() {
                this.notificationOpen = !this.notificationOpen;
            },

            onClickOutside (e, el) {
                this.notificationOpen = false;
            }
        },

        mounted() {
            this.totalCount = this.value;
        },

        destroyed() {

        }
    }
</script>

<style scoped>
    .notification-circle {width: 15px;height: 15px;border-radius: 50%;}
</style>


// WEBPACK FOOTER //
// Content/src/components/Notification.vue